import React, { useState, useMemo } from 'react';
import { Avatar, Col, Row, Dropdown, Menu, Button } from 'antd';
import { Share } from 'arcl';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { faShare } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ShareButton from 'Src/alumniGiving/campaign/blocks/share';
import { PAGE_TYPE_CROWDFUNDING, PAGE_TYPE_COMPETITIVE_FUNDRAISING } from 'Src/alumniGiving/constants';

import ThemeXSignInModal from '../themeXSignInModal';
import './style.scss';

function ThemeXHeader({
  userData,
  showLoginButton = true,
  title,
  showShare,
  shareUrl,
  disableLogoRedirect = false,
  hideLoginModal = false,
}) {
  const [showLoginModal, toggleLoginModal] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const nextUrl = window.location.pathname;
  const isCompetitiveOrCrowdfundingGiving = useMemo(() => {
    return [PAGE_TYPE_CROWDFUNDING, PAGE_TYPE_COMPETITIVE_FUNDRAISING].includes(window?.pageData?.type);
  }, [window?.pageData?.type])

  const userMenu = (
    <Menu>
      <Menu.Item key="profile">
        <a href={userData?.profile_url || '/'} tabIndex={0}>
          My Profile
        </a>
      </Menu.Item>
      <Menu.Item key="logout">
        <a href="/logout" tabIndex={0}>
          Logout
        </a>
      </Menu.Item>
    </Menu>
  );

  // Antd renders an <a class="ant-btn"> when given href, so consumers that navigate to /login
  // announce this as a link with no visual change; those that open the sign-in modal keep a button.
  const loginUrl = hideLoginModal ? `/login?next=${nextUrl}` : '';

  return (
    <header>
      <Row className="themex-header" type="flex" align="middle" justify="space-between">
        <Col>
          <a href="/" className="arc-focus-outline" disabled={disableLogoRedirect}>
            <img src={window.customerLogo} alt={`${window.collegeName} logo`} className="header-logo" />
            <If condition={title}>
              <span className="arc-p arc-font-weight-medium ml8">{title}</span>
            </If>
          </a>
        </Col>
        <Col className='arc-d-flex arc-flex-align-items-center'>
          <Choose>
            <When condition={showShare}>
              <Share title="Share" url={shareUrl} disableNativeShare>
                <div className="share-card-icon-text">
                  <span id="share-trigger" className="arc-anchor">
                    <span>Share</span>
                  </span>
                  <FontAwesomeIcon icon={faShare} className="ml12 arc-color-primary" />
                </div>
              </Share>
            </When>
            <Otherwise>
              <Choose>
                <When condition={userData}>
                  <Dropdown
                    overlay={userMenu}
                    placement="bottomRight"
                    trigger={['click']}
                    onVisibleChange={(visible) => {
                      setIsUserMenuOpen(visible);
                      if (!visible) return;
                      // Focus first menu item when dropdown opens
                      setTimeout(() => {
                        const firstMenuItem = document.querySelector('.ant-dropdown-menu-item:first-child a');
                        if (firstMenuItem) {
                          firstMenuItem.focus();
                        }
                      }, 100);
                    }}>
                    <Button
                      type="link"
                      className="link-btn arc-focus-outline"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          e.currentTarget.click();
                        }
                      }}
                      aria-label="User menu"
                      aria-haspopup="true"
                      aria-expanded={isUserMenuOpen}>
                      <Avatar className="mr8" alt="Profile Picture" src={userData?.present_picture} />
                      <FontAwesomeIcon icon={faChevronDown} />
                    </Button>
                  </Dropdown>
                </When>
                <Otherwise>
                  <If condition={showLoginButton}>
                    <Button
                      type="primary"
                      className="arc-btn-subtle arc-focus-outline"
                      id="login-button"
                      href={loginUrl || undefined}
                      onClick={loginUrl ? undefined : () => toggleLoginModal(true)}>
                      Login
                    </Button>
                  </If>
                </Otherwise>
              </Choose>
            </Otherwise>
          </Choose>
          <If condition={isCompetitiveOrCrowdfundingGiving}>
            <div className="giving-share arc-d-flex arc-flex-vertical-align arc-flex-justify-center ml12 mr12">
              <ShareButton title={window?.pageData?.name} url={window?.pageData?.page_url} />
            </div>
          </If>
        </Col>
      </Row>
      <ThemeXSignInModal visible={showLoginModal} handleClose={() => toggleLoginModal(false)} />
    </header>
  );
}

export default ThemeXHeader;
